/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SubmitClipResponse, SubmitClipVars } from '../openapi-types.gen.js';

export type { SubmitClipResponse, SubmitClipVars } from '../openapi-types.gen.js';

export const useSubmitClip = createMutationHook<SubmitClipVars, SubmitClipResponse, unknown>({
  specName: 'useSubmitClip',
  path: '/v1/rewards/content/clip',
  method: 'POST',
  resolveUrl: (vars: SubmitClipVars) => `/v1/rewards/content/clip`,
  buildBody: (vars: SubmitClipVars) => ({ tweetUrlOrId: vars.tweetUrlOrId }),
  parseResponse: (raw: unknown): SubmitClipResponse => raw as SubmitClipResponse,
  
  
  
});
